__turbopack_context__.v({
  "content": "Layout-module-scss-module__YbS5_G__content",
  "footer": "Layout-module-scss-module__YbS5_G__footer",
  "mobileMenu": "Layout-module-scss-module__YbS5_G__mobileMenu",
  "navigation": "Layout-module-scss-module__YbS5_G__navigation",
  "pageContent": "Layout-module-scss-module__YbS5_G__pageContent",
  "topInfoBanner": "Layout-module-scss-module__YbS5_G__topInfoBanner",
});
